module.exports = __webpack_public_path__ + "img/companyIntro18.d214c983.png";